import { render, staticRenderFns } from "./RelateModalForm.vue?vue&type=template&id=bda05a44&"
import script from "./RelateModalForm.vue?vue&type=script&lang=js&"
export * from "./RelateModalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports